<template>
  <CoachingFeedbackTask v-if="task.origin === 'coach'" :task="task" />
  <SelfFeedbackTask
    v-else-if="task.origin === 'personal' && task.owner.id === user.id && task.isSelfFeedbackOnly"
    :task="task"
  />
  <UnfinishedFeedbackTask
    v-else-if="task.origin === 'personal' && task.owner.id === user.id && !task.isSelfFeedbackOnly"
    :task="task"
  />
  <RequestFeedbackTask
    v-else-if="task.origin === 'personal' && task.owner.id !== user.id"
    :task="task"
  />
  <SelfAssessmentFeedbackTask
    v-else-if="
      task.origin === 'assessment' &&
      task.surveyTandems.length === 1 &&
      task.surveyTandems[0].receiver.id === user.id
    "
    :task="task"
  />
  <AssessmentFeedbackTask v-else-if="task.origin === 'assessment'" :task="task" />
</template>

<script setup lang="ts">
  import type { FeedbackTask } from '@/modules/task/composables/useFeedbackTasks'
  import CoachingFeedbackTask from './CoachingFeedbackTask.vue'
  import { useUserStore } from '@/stores/user.store'
  import SelfFeedbackTask from './SelfFeedbackTask.vue'
  import RequestFeedbackTask from './RequestFeedbackTask.vue'
  import SelfAssessmentFeedbackTask from './SelfAssessmentFeedbackTask.vue'
  import AssessmentFeedbackTask from './AssessmentFeedbackTask.vue'
  import UnfinishedFeedbackTask from './UnfinishedFeedbackTask.vue'

  defineProps<{
    task: FeedbackTask
  }>()
  const { user } = useUserStore()
</script>
